<template>
  <div>
    <v-list class="pa-0 done-by-users-list mt-1"
            v-if="$vuetify.breakpoint.name === 'xs'">

      <v-list-item v-for="(expense, index) in expenses"
                   :key="index"
                   class="pt-2 pb-2"
                   style="min-height: unset">
        <v-list-item-content class="pa-0">
          <v-list-item-title>
            <div class="d-flex flex-row align-baseline">
              <div class="mr-3">
                <v-text-field v-model="expense.name"
                              hide-details="auto"
                              outlined
                              dense
                              :placeholder="$t('service.expense')"
                              :rules="[buildMaxLengthValidator(2456), buildRequiredValidator(),]"/>
              </div>
              <div class="d-flex flex-row align-baseline">
                <v-text-field v-model="expense.cost"
                              hide-details="auto"
                              dense
                              outlined
                              type="number"
                              class="mr-2 mt-1 mb-1 right-align-number-input"
                              style="max-width: 5em;"
                              :rules="[buildRequiredValidator(),]"/>
                <div class="mr-3">{{ $t('common.moneyUnit') }}</div>
              </div>
            </div>
            <v-divider/>
          </v-list-item-title>

        </v-list-item-content>
        <v-list-item-action class="ma-0">
          <v-btn @click="removeRow(expense)"
                 icon :title="$t('actions.delete')">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="pa-0">
          <div>
          <v-btn @click="addRow"
                 small>
            <v-icon>mdi-circle-plus</v-icon>
            {{ $t('actions.add') }}
          </v-btn>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>


    <v-data-table
        v-if="$vuetify.breakpoint.name !== 'xs'"
        :headers="headers"
        class="elevation-1 done-by-users-table"
        hide-default-footer
        :items="expenses"
        dense
        :no-data-text="'-'">

      <template v-slot:[`item.name`]="{ item }">
        <v-text-field v-model="item.name"
                      hide-details="auto"
                      outlined
                      dense
                      :rules="[buildMaxLengthValidator(2456), buildRequiredValidator(),]"/>
      </template>

      <template v-slot:[`item.cost`]="{ item }">
        <div class="d-flex flex-row align-baseline">
          <v-text-field v-model="item.cost"
                        hide-details="auto"
                        dense
                        outlined
                        type="number"
                        class="mr-2 mt-1 mb-1 right-align-number-input"
                        style="max-width: 5em;"
                        :rules="[buildRequiredValidator(),]"/>
          <div class="mr-3">{{ $t('common.moneyUnit') }}</div>
          <v-btn @click="removeRow(item)"
                 icon :title="$t('actions.delete')">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:footer>
        <div class="v-data-footer justify-start">
          <v-btn @click="addRow"
                 small
                 class="mt-1 mb-1">
            <v-icon>mdi-circle-plus</v-icon>
            {{ $t('actions.add') }}
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { buildRequiredValidator, buildMaxLengthValidator } from '@/utils/ValidatorBuilders';

export default {
  name: 'ExpensesInput',
  components: {},
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  data: () => ({}),
  methods: {
    buildMaxLengthValidator,
    buildRequiredValidator,

    addRow() {
      const row = { name: null, cost: null };

      this.expenses.push(row);
    },
    removeRow(row) {
      this.expenses = this.expenses.filter((expenceRow => expenceRow !== row));
    },
  },

  computed: {
    expenses: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },


    headers() {
      return [
        {
          text: this.$t('service.expense'),
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: this.$t('service.expenseCost'),
          align: 'start',
          sortable: false,
          value: 'cost',
        },

      ];
    },
  },
};
</script>

<style>

</style>
